import React from 'react';
import { WingBlank, WhiteSpace } from 'antd-mobile'
class Index extends React.Component {

    componentDidMount() {

    }
    calc() {
        let standerScore = 20;
        let text = "你的得分是：" + standerScore + "，";
        if (standerScore < 53) {
            text += "没有抑郁症"
        } else if (standerScore >= 53 && standerScore < 62) {
            text += "患有轻度抑郁"
        } else if (standerScore >= 63 && standerScore < 72) {
            text += "患有轻度抑郁"
        } else if (standerScore > 72) {
            text += "患有重度抑郁"
        }
        return text
    }
    duice() {
        let standerScore = 20;
        let text = "";
        if (standerScore < 53) {
            text += "没有抑郁症"
        } else if (standerScore >= 53 && standerScore < 62) {
            text += "患有轻度抑郁"
        } else if (standerScore >= 63 && standerScore < 72) {
            text += "患有轻度抑郁"
        } else if (standerScore > 72) {
            text += "患有重度抑郁"
        }
        return text
    }
    render() {
        return (
            <div className="result">
                <WhiteSpace />
                <WingBlank>
                    <h3 className="l_title">测试结果</h3>
                    <div className="text">
                        <p>{this.calc()}</p>
                    </div>
                    <h3 className="l_title">一些建议</h3>
                    <div className="text">
                        <p></p>
                    </div>
                    <h3 className="l_title">量表介绍</h3>
                    <div className="text">
                        <p>1、SDS主要适用于具有抑郁症状的成年人，它对心理咨询门诊及精神科门诊或住院精神病人均可使用。对严重阻滞症状的抑郁病人，评定有困难。</p>
                        <p>2、关于抑郁症状的分级，除测试分值外，主要还要根据临床症状。特别是要害症状的程度来划分，测试分值仅能作为一项参考指标而非绝对标准。</p>
                    </div>
                </WingBlank>
            </div>
        );
    }
}

export default Index;
